class AskQuestion extends HTMLElement {
  constructor() {
    super();
    this.modal = document.getElementById('bt-form-ask-question-modal');
    this.selectors = {
      openButton: '[data-open-ask-question]',
      container: '.bt-product-addon',
      formSuccess: '.bt-form-ask__success',
    };

    MicroModal.init();
  }

  connectedCallback() {
    this.container = document.querySelector(this.selectors.container);
    if (this.modal) {
      this.init();
    }
  }

  init() {
    this.showSuccessMessage();
    addEventDelegate({
      selector: this.selectors.openButton,
      handler: (e) => {
        e.preventDefault();
        MicroModal.show(this.modal.id, {
          onShow: (modal) => {
            document.body.classList.add('bt-opened-modal');
          },
          onClose: (modal) => {
            document.body.classList.remove('bt-opened-modal');
          },
        });
      },
    });
  }
  showSuccessMessage() {
    const successMessage = this.container.querySelector(this.selectors.formSuccess);
    if (successMessage) {
      UtenzoTheme.Notification.show({
        target: document.body,
        method: 'appendChild',
        type: 'success',
        message: successMessage.dataset.message,
        delay: 2000,
        sticky: false,
      });

      setTimeout(() => {
        const url = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, url);
      }, 2500);
    }
  }
}
customElements.define('bt-ask-question', AskQuestion);
